export default {
  zones: [],
  zone: {},
};
